<template>
  <div class="main">
    <div class="main_bg">
      <div>
        <contentMenu :index="3"></contentMenu>
      </div>
      <div class="banner" style="position: relative;">
        <img :src="imageurlMobile" style="width: 100%" />
      </div>
      <div class="main2-content">
        <div class="layout-flex">
          <div
            class="item-img-content"
            v-for="(item,index) in list"
            :key="index"
            @click="handleTabs(index+1)"
          >
            <img class="item-img" :src="item.imageurlMobile" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentMenu from "./contentMenuMobile.vue";
import contentLeft from "./contentLeftMobile.vue";
import contentRight from "./contentRightMobile.vue";
export default {
  components: {
    contentMenu,
    contentLeft,
    contentRight
  },
  data() {
    return {
      imageurlMobile: require("../../assets/meb/imgsMobile/cjgy/mCjgyBan@2x.png"),
      list: [
        {
          imageurlMobile: require("../../assets/meb/imgsMobile/cjgy/mCjgy1@2x.png")
        },
        {
          imageurlMobile: require("../../assets/meb/imgsMobile/cjgy/mCjgy2@2x.png")
        },
        {
          imageurlMobile: require("../../assets/meb/imgsMobile/cjgy/mCjgy3@2x.png")
        },
        {
          imageurlMobile: require("../../assets/meb/imgsMobile/cjgy/mCjgy4@2x.png")
        },
        {
          imageurlMobile: require("../../assets/meb/imgsMobile/cjgy/mCjgy5@2x.png")
        }
      ]
    };
  },
  mounted() {},
  methods: {
    handleTabs(index) {
      let route = this.$router.resolve({
        name: "workshop",
        query: { index: index }
      });
      window.open(route.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 375px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 375px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
}
.divHeight {
  height: 23px;
}
.btn {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 151px;
  height: 50px;
  cursor: pointer;
}
.main2-content {
  .layout-flex {
    width: 375px;
    padding: 20px 10px 20px 10px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    .item-img-content {
      width: 355px;
      height: 150px;
      margin-top: 15px;
    }
    .item-img {
      width: 355px;
      height: 150px;
    }
  }
}
</style>
